import React from 'react';
import { SwipeableDrawer as BaseSwipeableDrawer, SxProps } from '@mui/material';

import { useStyles } from './styles';
import { ISwipeableDrawer } from './interfaces';

const SwipeableDrawer = ({
  position,
  onOpen,
  onClose,
  open,
  children,
  sx = {},
  ...props
}: ISwipeableDrawer) => {
  const classes = useStyles(position);

  return (
    <BaseSwipeableDrawer
      {...props}
      anchor={position?.horizontal}
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      hideBackdrop
      disableBackdropTransition
      closeAfterTransition
      ModalProps={{
        keepMounted: false,
      }}
      SwipeAreaProps={{ style: { display: 'none' } }}
      sx={{ ...classes.root, ...sx } as SxProps}
    >
      {children}
    </BaseSwipeableDrawer>
  );
};

export default SwipeableDrawer;
